import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import FaqService from "../../../services/KangarooServices/FaqService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import NewsLetterForm from "../component/NewsLetterForm";
import NewLetterService from "../../../services/KangarooServices/NewLetterService";
import UnsubscribeModal from "../../../Components/Common/Unsubscribe";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const NewsLetter = () => {
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  console.log("🚀 ~ FAQGroup ~ selectedCustomer:", selectedCustomer);
  const navigate = useNavigate();
  const [data, setdata] = useState([]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const toggleModal = () => {
    setAddModal(!addModal);
  };
  const fetchdata = async () => {
    try {
      const data = await NewLetterService.getList();
      setdata(data);
      console.log("Fetched user:", data);
    } catch (error) {
      console.error("Error getting user:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchdata();
  }, []);
  console.log("data");

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    // {
    //   name: "Name",
    //   selector: (row) => `${row.firstName} ${row.lastName}`,
    //   cell: (row) => (
    //     <Link to={`/customer/${row?.id}`}>
    //       {row.firstName} {row.lastName}
    //     </Link>
    //   ),
    //   sortable: true,
    // },
    {
      name: "Email Address",
      selector: (row) => row.email,

      sortable: true,
    },
    {
      name: "Subscribed?",
      selector: (row) => row.isUnsubscribed,
      sortable: true,
      cell: (row) => (
        <Badge color={row.isUnsubscribed ? "danger" : "success"}>
          {row.isUnsubscribed ? "No" : "Yes"}
        </Badge>
      ),
    },

    {
      name: "Action",
      selector: (row) => (
        <div>
          {!row?.isUnsubscribed ? (
            <Button
              className="btn btn-soft-danger btn-sm ms-1"
              color="danger"
              onClick={() => handleDeleteClick(row)}
              title="Unsubscribe"
            >
              <i class="bx bx-bell-off"></i>
            </Button>
          ) : null}
        </div>
      ),
      center: true,
    },
  ];

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = data?.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.email || ""} ${
      pkg?.isUnsubscribed || ""
    }`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedCustomer) {
      try {
        await NewLetterService.update(selectedCustomer?.email);
        fetchdata();
        toast.success("Unsubscribed Successfull");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Newsletter" pageTitle="Location & Affiliation" />
      </div>
      <Row>
        <Col md={8} xs={10} className="">
          <InputGroup>
            <Input
              placeholder="Search by email"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className=" justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            + Subscribe
          </button>
        </Col>
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>

      {/* <MobileCustomerForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedCustomer(null); // Clear editing state when closing
        }}
        setCustomerList={setCustomerList}
        customerList={customerList}
        selectedCustomer={selectedCustomer}
        fetchdata={fetchdata}
      /> */}

      <NewsLetterForm
        isOpen={addModal}
        toggle={toggleModal}
        fetchdata={fetchdata}
        selectedItem={selectedCustomer}
      />
      <UnsubscribeModal
        show={deleteModal}
        onUnsubscribeClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedCustomer} // Pass the selected item
      />
    </div>
  );
};

export default NewsLetter;
